import $ from 'jquery';

var hash;
export default class Production1 {
  constructor(app) {
    this.app = app;
    this.getData();
  }
  getData() {
    var productionCat_arr;
    var productionCat_xhr = new XMLHttpRequest();
    productionCat_xhr.open('get', this.app.host + '/api/categorys', true);
    productionCat_xhr.send();
    productionCat_xhr.onload = function() {
      if (productionCat_xhr.status == 200) {
        productionCat_arr = JSON.parse(productionCat_xhr.responseText);
        console.log(productionCat_arr);
        for (var i = 0; i < productionCat_arr.data.length; i++) {

          if (productionCat_arr.data[i].id == 1) {
            //
            // $('.hashSlider').append('' +
            //   '<a href="#sub' + productionCat_arr.data[i].id + '" >' +
            //   '<div class="hashlink__item">' +
            //   '<h5>' + productionCat_arr.data[i].name + '</h5>' +
            //   '</div>' +
            //   '</a>'
            // )
            $('.sub__box').append('' +
              '<div class="page-content sub' + productionCat_arr.data[i].id + '">' +
              '<div class="submenu">' +
              '</div>' +
              '<div class="prod">' +
              '</div>' +
              '</div>'
            )
            this.getSubCate(productionCat_arr.data[i].id)
          } else {

          }
        }
        // this.setSlider();
        this.hashchange();
      }
    }.bind(this)
  }
  getSubCate(id) {
    var cate_arr;
    var cate_xhr = new XMLHttpRequest();
    cate_xhr.open('get', this.app.host + '/api/productsByCategory/' + id, true);
    cate_xhr.send();
    cate_xhr.onload = function() {
      if (cate_xhr.status == 200) {
        cate_arr = JSON.parse(cate_xhr.responseText);
        console.log(cate_arr);
        var k = 0;
        for (var x in cate_arr.data) {
          console.log(x);
          k++;

          $('.hashSlider').append('' +
            '<a href="#sub' + id + '?sm=' + k + '" >' +
            '<div class="hashlink__item">' +
            '<h5>'  + x + '</h5>' +
            '</div>' +
            '</a>'
          )
          // $('.sub' + id + ' .submenu').append('' +
          //   '<a class=" index__button" href="#sub' + id + '?sm=' + k + '">' + x + '</a>'
          // )
          for (var i = 0; i < cate_arr.data[x].length; i++) {
            $('.sub' + id + ' .prod').append('' +
              '<a class="prod__item" href="#sub' + id + '?sm=' + k + '&id=' + cate_arr.data[x][i].id + '">' +
              '<div class="prod__img">' +
              '<img src="' + this.app.host + cate_arr.data[x][i].medias[0].path + '" />' +
              '</div>' +
              '<h4 class="prod__title">' + cate_arr.data[x][i].title + '</h4>' +
              '</a>'
            )
          }
        }
      }
    }.bind(this)
  }
  getProd() {
    var prod_arr;
    var prod_xhr = new XMLHttpRequest();
    prod_xhr.open('get', this.app.host + '/api/products', true);
    prod_xhr.send();
    prod_xhr.onload = function() {
      if (prod_xhr.status == 200) {
        prod_arr = JSON.parse(prod_xhr.responseText);
        console.log(prod_arr);
        for (var x in prod_arr.data) {
          console.log(x);
        }
        this.setSlider();
        this.app.updatePage();
      }
    }.bind(this)
  }

  setSlider() {

    $('.hashSlider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      touchMove: false,
      mobileFirst: false,
      autoplay: false,
      arrows: true,
      responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
      ]
    })
  }
  refreshSlder() {
    
    $(".hashSlider").slick('setPosition');
  }
  getDetail(pid) {

    var detail_arr;
    var detail_xhr = new XMLHttpRequest();
    detail_xhr.open('get', this.app.host + '/api/products/' + pid, true);
    detail_xhr.send();
    detail_xhr.onload = function() {
      if (detail_xhr.status == 200) {
        detail_arr = JSON.parse(detail_xhr.responseText);
        $('.detail .detail__img img').attr('src', this.app.host + detail_arr.data[0].medias[0].path);
        $('.detail .detail__text .title').html('' + detail_arr.data[0].title);
        $('.detail .detail__text .subtitle').html('' + detail_arr.data[0].content_desc);
        $('.detail').show();
        $('.prod').hide();
      }
    }.bind(this)
  }
  hashchange() {
    //
    hash = this.app.hash;
    this.hashId = hash.replace("sub", "");
    // console.log(this.hashId);
    // console.log(this.app.prodId);
    // console.log(this.app.sm , "ssm");
    if (this.app.prodId == "") {
      $('.detail').hide();
      $('.prod').show();
    } else {
      this.getDetail(this.app.prodId);
    }
    this.getProd();
    this.refreshSlder();
  }
}
